module.exports = __webpack_public_path__ + "img/acnh.a1f90f18.png";